import React, { useState } from 'react'
import moment from 'moment'
import Tippy, { tippy, useSingleton } from "@tippyjs/react";
// import tippy from 'tippy.js';
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light.css';
import {Link} from 'react-router-dom'
/**
 * 
 * @param {*} param0 
 * @returns 
 */
export function CustomBarChart({
	id = "",
	data = {},
	width = '100%' ,
	height = 60 ,
	barColor = '#F44336' ,
	period = 90, // days 
	 
	}){

		
	const [source, target] = useSingleton({
		overrides: ["placement", "interactive","theme"]
	});
	
			 
	// else ...
	return (
		<div className='sm-barChart'>
			
			<Tippy
				singleton={source}
				// delay={500}
				// Uncomment for transitions!
				// moveTransition="transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)"
			/>
			<div className="barChart-content">
				{
					[...Array(period)].map( (item,idx) => {

						const date = moment().startOf("day").subtract(parseFloat(period - idx)-1, "days")
						let is_outage = false , outage = 0 , uptime = 100 ;
						// ////console.log(date.format('YYYY-MM-DD') , data?.incidents ?? {});
						if(data?.data && data?.data[date.format('YYYY-MM-DD')]){
							is_outage = true;
							outage = (data?.data[date.format('YYYY-MM-DD')]?.outage_delay / 3600 ) ?? 0;
						} 
							
						
						return <Tippy 
							singleton={target}
							key={idx} 
							interactive = {true} 
							allowHTML={true}
							content={<ContentTooltip 
								date={date} 
								// value={item.value} 
								incidents={(data?.data && data?.data[date.format('YYYY-MM-DD')])?.incidents ?? []} 
								outage={outage} 
								is_outage={is_outage}
								// startTimeLocalOutage={item?.startTimeLocalOutage}
								// endTimeLocalOutage={item?.endTimeLocalOutage}
								/>}
							placement={`bottom`}
							theme='light'
							
							>
							<span className='bar-item' date={date.format()}
								style={{
									backgroundColor : (
											
										is_outage === true
										? (
											outage <= 8
											? '#ffb500'
											: outage > 8 && outage <=16
												? '#ff9200'
												: '#f53838'
										)
										: uptime > 0
											? "#00f300"//"#00d100"//this.state.chartColor
											: '#dfdfdf' 
												
									)
								}}
							></span></Tippy>
					})
				}
			</div>
		</div>


	)
	 
}

/**
 * CHART WITHOUT TOOLTIP
 * @param {*} param0 
 * @returns 
 */
export function BarChartDemo({
	id = "",
	data = {},
	width = '100%' ,
	height = 60 ,
	barColor = '#F44336' ,
	period = 90, // days 
	 
	}){

 

		 
	return (
		<div className='sm-barChart'>
			<div className="barChart-content">
				{
					[...Array(period)].map( (item,idx) => {

						const date = moment().startOf("day").subtract(parseFloat(period - idx)-1, "days")
						let is_outage = false , outage = 0 , uptime = 100 ;
						// ////console.log(date.format('YYYY-MM-DD') , data?.incidents ?? {});
						if(data?.data && data?.data[date.format('YYYY-MM-DD')]){
							is_outage = true;
							outage = (data?.data[date.format('YYYY-MM-DD')]?.outage_delay / 3600 ) ?? 0;
						} 
							
						
						return <span 
								key={idx} 
								className='bar-item' 
								date={date.format()}
								style={{
									backgroundColor : (
											
										is_outage === true
										? (
											outage <= 8
											? '#ffb500'
											: outage > 8 && outage <=16
												? '#ff9200'
												: '#f53838'
										)
										: uptime > 0
											? "#00f300"//"#00d100"//this.state.chartColor
											: '#dfdfdf' 
												
									)
								}}
							></span> 
					})
				}
			</div>
		</div>


	)
	   
	   
   

}
 

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ContentTooltip = ({ date, value , incidents = [] , outage , is_outage , startTimeLocalOutage, endTimeLocalOutage }) => {
	return (
		<div className='custom-tooltip'>
		<div className='custom-tooltip-inner'>
			<div className='tooltip-header'>
				<div className="h-date">{moment(date).format('DD MMM YYYY')}</div>
				{ outage > 0 && <div className="h-outage-delay">{moment.duration(outage , 'hour').humanize()} outage</div> }
			</div>
			<div className="tooltip-content">
				{
					incidents?.length > 0 
					? (
						<ul>
							{
								incidents.map( (incident , index) => {
									return (
										<li key={index}><Link href={`/incidents/${incident?.id}`} passHref><a>{incident?.name}</a></Link></li>
									)
								})
							}
						</ul>
					)
					: <div className='no-outages-msg'>No downtime recorded on this day.</div>
				
				}
			</div>
		</div>
		</div>
	)
	 
};
 

